/* eslint-disable */
<!--
    File Name: ProgramsList.vue
    Description: List of Programs
-->
<template>
  <div id="page-programs">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown class="cursor-pointer" vs-trigger-click>
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2">
                {{
                  apiCurrentPage == 1
                    ? apiCurrentPage
                    : apiCurrentPage * pageSize - (pageSize - 1)
                }}
                -
                {{ (apiCurrentPage || 1) * (pageSize || 20) }}
                {{ $t('crud.filters.of') }} {{ totalRows }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="setSize(20)">
                <span>20</span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="setSize(50)">
                <span>50</span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="setSize(100)">
                <span>100</span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="setSize(150)">
                <span>150</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <div
          class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
        >
          <vs-input
            @input="updateSearchQuery"
            class="mb-4 md:mb-0 mr-4 ml-md-4"
            v-bind:placeholder="$t('messages.filters.search')"
            v-model="searchQuery"
          />
          <vs-button
            class="mb-4 md:mb-0 mr-4"
            @click.prevent="openModal"
            @submit.stop
            v-if="$can('create programs')"
          >
            {{ $t('messages.create.title') }}
          </vs-button>
        </div>
      </div>
      <ag-grid-vue
        id="grid-wrapper"
        :animateRows="true"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :floatingFilter="false"
        :gridOptions="gridOptions"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :rowData="programs"
        :suppressPaginationPanel="true"
        :frameworkComponents="frameworkComponents"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        colResizeDefault="shift"
        rowSelection="multiple"
        @model-updated="refresh"
        :overlayNoRowsTemplate="$t('without_results')"
        @first-data-rendered="onFirstDataRendered"
      ></ag-grid-vue>
      <vs-pagination
        :max="maxPageNumbers"
        :total="totalPages"
        v-model="currentPage"
      />
    </vx-card>

    <FormProgram ref="FormProgram"></FormProgram>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import axios from 'axios'
import Actions from '@/components/Actions.vue'
import Swal from 'sweetalert2'
import FormProgram from './FormProgram.vue'

export default {
  components: {
    AgGridVue,
    FormProgram
  },
  data() {
    return {
      searchQuery: '',
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      totalPages: 0,
      totalRows: 0,
      pageSize: 20,
      apiCurrentPage: undefined,
      frameworkComponents: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      programs: []
    }
  },
  beforeMount() {
    this.frameworkComponents = {
      Actions
    }
  },
  watch: {
    '$store.state.windowWidth'() {
      this.gridApi.sizeColumnsToFit()
    }
  },
  methods: {
    refresh() {
      this.gridApi.sizeColumnsToFit()
    },
    async openModal() {
      await this.$refs.FormProgram.getRoutines()
      this.$refs.FormProgram.showModal()
    },
    async openModalEdit(uuid) {
      if (uuid !== null) {
        this.$refs.FormProgram.form.uuid = uuid
        await this.$refs.FormProgram.getProgram(uuid)
      }
      this.openModal()
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit()
    },
    async deleteItem(uuid) {
      let message_content = null
      let message_type = null
      const { value } = await Swal.fire({
        icon: 'warning',
        title: this.$t('messages.delete.messages.confirmation'),
        text: this.$t('messages.delete.messages.confirmation_description'),
        showCancelButton: true,
        cancelButtonColor: '#d33',
        focusCancel: true,
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('cancel')
      })

      if (value) {
        this.$vs.loading({ container: '.vx-card__body' })

        try {
          await axios.delete(
            `${process.env.VUE_APP_API_URL}/api/programs/${uuid}`
          )
          message_type = 'success'
          message_content = 'messages.delete.messages.success'
          this.showMessageToast(message_type, message_content)
          this.getPrograms()
        } catch (error) {
          this.$vs.loading.close('.vx-card__body > .con-vs-loading')
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.error &&
            error.response.data.error.message
          ) {
            Swal.fire({
              icon: 'error',
              title: this.$t('messages.errors.title'),
              text: error.response.data.error.message,
              confirmButtonText: this.$t('ok')
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: this.$t('messages.errors.title'),
              text: this.$t('messages.errors.description'),
              confirmButtonText: this.$t('ok')
            })
          }
        }
      }
    },
    showMessageToast(message_type, message_content) {
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
      Toast.fire({
        icon: message_type,
        title: this.$t(message_content)
      })
    },
    updateSearchQuery: _.debounce(function () {
      // eslint-disable-next-line no-invalid-this
      this.getPrograms()
    }, 500),
    setSize(val) {
      this.pageSize = val
      this.gridApi.paginationSetPageSize(val)
      this.getPrograms()
    },
    async getPrograms() {
      this.$vs.loading({ container: '.vx-card__body' })

      const params = {
        page: this.apiCurrentPage,
        size: this.pageSize,
        filter: this.searchQuery
      }

      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/programs`,
          {
            params
          }
        )
        this.totalPages = data.last_page
        this.totalRows = data.total
        this.programs = data.data
        this.$vs.loading.close('.vx-card__body > .con-vs-loading')
      } catch (error) {
        this.$vs.loading.close('.vx-card__body > .con-vs-loading')
        console.log('Ocurrió un error:', error)
      }
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('programs.table.columns.title'),
          sortable: false,
          minWidth: 250,
          field: 'title'
        },
        {
          headerName: this.$t('programs.table.columns.price'),
          sortable: false,
          minWidth: 250,
          valueGetter: function (params) {
            const formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD'
            })
            return formatter.format(params.data.product !== null ? params.data.product.price : 0)
          }.bind(this)
        },
        {
          headerName: this.$t('programs.table.columns.created_at'),
          sortable: false,
          minWidth: 380,
          maxWidth: 380,
          valueGetter: function (params) {
            return this.$moment(params.data.created_at).format('LLLL')
          }.bind(this)
        },
        {
          headerName: this.$t('options'),
          cellRendererFramework: 'Actions',
          minWidth: 160,
          maxWidth: 160,
          cellRendererParams: {
            actionsCrud: [
              {
                name: 'edit',
                permission: 'edit programs',
                callback: this.openModalEdit
              },
              {
                name: 'delete',
                permission: 'delete programs',
                callback: this.deleteItem
              }
            ]
          }
        }
      ]
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 20
    },
    currentPage: {
      get() {
        return this.apiCurrentPage || undefined
      },
      set(val) {
        this.apiCurrentPage = val
        this.getPrograms()
      }
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
  },
  metaInfo() {
    return { title: this.$t('programs.title') }
  }
}
</script>
/* eslint-enable */
